import React, { Component } from 'react';
import { Button } from 'antd-mobile'
import { createBrowserHistory } from "history";
import './style.less';
const history = createBrowserHistory();
export class Item extends Component {
    constructor(props) {
        super(props);
        this.state = {
            crmPack: this.props.crmPack,
            mpPack: this.props.mpPack,
            cardid: this.props.cardid,
            mcno: this.props.mcno
        }
    }
    onClick = (data, e) => {
        let orderment = {
            packageType: 2, cardid: this.state.cardid, mcno: this.state.mcno,
        };
        localStorage.setItem('orderment', JSON.stringify(orderment));
        history.push(`/package/details/${data.clientpackageid}/2`);
      //  history.push(`/package/details/${data.clientpackageid}/${data.name}/2`);
        history.go();
    }
    onClick2 = (data, e) => {
        let orderment = {
            packageType: 0, cardid: this.state.cardid, mcno: this.state.mcno,
        };
        localStorage.setItem('orderment', JSON.stringify(orderment));
        history.push(`/package/details/${data.packid}/1`);
      //  history.push(`/package/details/${data.packid}/${data.packname}/1`);
        history.go();
    }
    render() {
        const { crmPack, mpPack } = this.state;
        return <div className="ordermentItem" style={{ height: document.documentElement.clientHeight - 80, backgroundColor: '#ffffff' }}>
            {
                crmPack === undefined ? '' :
                    crmPack.map((data, index) => (
                        <div className="item" key={index} >
                            <div className="iteml">
                                <div className="name">{data.name}</div>
                                <div className="text">所需积分：<span>{data.realprice}</span>
                                    {
                                        parseFloat(data.realprice) === parseFloat(data.marketprice) ? '' :
                                            <span className="yh">{data.marketprice}</span>
                                    }
                                </div>
                            </div>
                            <Button className="itemr" onClick={this.onClick.bind(this, data)}>套餐详情</Button>
                        </div>
                    ))
            }
            {
                mpPack === undefined ? '' :
                    mpPack.map((data, index) => (
                        <div key={index}>
                            <div className="item"  >
                                <div className="iteml">
                                    <div className="name">{data.packname}</div>
                                    <div className="text">所需积分：<span>{data.realprice}</span>
                                        {
                                            parseFloat(data.realprice) === parseFloat(data.marketprice) ? '' :
                                                <span className="yh">{data.marketprice}</span>
                                        }
                                    </div>
                                </div>
                                <Button className="itemr" onClick={this.onClick2.bind(this, data)}>套餐详情</Button>

                            </div>

                        </div>
                    ))

            }

        </div>;
    }
}